const logError = (e) => {
  // eslint-disable-next-line no-console
  console.warn(e);
};

export default logError;